'use strict'

function clean (value) {

  return String(value == null ? '' : value).trim()
}

// A visible title is the field name. A placeholder is only the name when
// the title is empty, and then it is not also shown inside the field.
function fieldNameAndHint (title, placeholder) {

  const name = clean(title)
  const hint = clean(placeholder)

  if (name) {

    return {
      label: name,
      placeholder: hint && hint !== name ? hint : ''
    }
  }

  if (hint) return { label: hint, placeholder: '' }

  return { label: '', placeholder: '' }
}

module.exports = {
  fieldNameAndHint
}
